import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../../helpers/Helpers';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../../redux/reducers/authSlice';
import TableFooter from '../../../../components/TableFooter';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ToolbarWrapper } from '../../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../../components/RefreshButton';
import { useSortableColumns } from '../../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, ColumnFilterOption } from '../../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../../models/common/ColumnFilterModel';
import { FARKLI_DOVIZ } from '../../../../helpers/dipToplam';
import { tutarYaz } from '../../../../services/HgsOgsService';
import { durumRozeti, uyariRozeti } from '../../../../helpers/sigortaHesap';
import { ilkSigortaListIstegi, SIGORTA_SAYFASI, SigortaAracBilgisi, SigortaKaydi, SigortaListIstegi, SigortaSecenek, SigortaSecenekleri, SigortaService, SigortaToplamlari } from '../../../../services/SigortaService';
import SigortaListFilters from './Components/SigortaListFilters';
import SigortasizAraclarModal from './Components/SigortasizAraclarModal';

/**
 * Genel Giderler > Sigorta / Kasko (28.10.2026, #502): standart liste ekranı. Durum (Başlamadı / Devam Ediyor / Süresi Doldu)
 * ve Kalan Gün bugüne göre sunucuda hesaplanır; kalan gün rozeti 31+ normal, 0–30 yaklaşıyor, eksi süresi doldu.
 * Arama kutusu poliçe no + açıklama arar; diğer filtreler kolon filtresi (başlangıç tarihi aralığı dahil).
 * Kopyala: seçilen poliçeden yeni yılın poliçesi (eski poliçe değişmez).
 */
const SigortaList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pageName = SIGORTA_SAYFASI
    const pageVersion = "1";
    const [data, setData] = useState<{ list: SigortaKaydi[], totalRecordCount: number, toplamlar?: SigortaToplamlari }>({ list: [], totalRecordCount: 0 });
    const [filter, setFilter] = useState<SigortaListIstegi>(ilkSigortaListIstegi)
    const [sigortasizAcik, setSigortasizAcik] = useState<boolean>(false);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Araç Plaka', name: 'plaka', order: 0, isVisible: true },
            { title: 'Belge Türü', name: 'belgeTuruAdi', order: 0, isVisible: true },
            { title: 'Poliçe No', name: 'policeNo', order: 0, isVisible: true },
            { title: 'Durum', name: 'durumAdi', order: 0, isVisible: true },
            { title: 'Başlangıç Tarihi', name: 'baslangicTarihiStr', order: 0, isVisible: true },
            { title: 'Bitiş Tarihi', name: 'bitisTarihiStr', order: 0, isVisible: true },
            { title: 'Kalan Gün', name: 'kalanGun', order: 0, isVisible: true, className: 'text-end' },
            { title: 'Araç Cinsi', name: 'aracCinsi', order: 0, isVisible: true },
            { title: 'Sigorta Firması', name: 'sigortaFirmasi', order: 0, isVisible: true },
            { title: 'Acente', name: 'acente', order: 0, isVisible: true },
            { title: 'Tutar', name: 'tutar', order: 0, isVisible: true, className: 'text-end' },
            { title: 'Döviz Cinsi', name: 'dovizCinsi', order: 0, isVisible: true },
            { title: 'Teminat Bedeli', name: 'teminatBedeli', order: 0, isVisible: true, className: 'text-end' },
            { title: 'Ek Teminat Bedeli', name: 'ekTeminatBedeli', order: 0, isVisible: true, className: 'text-end' },
            { title: 'TL Karşılığı', name: 'tutarTL', order: 0, isVisible: false, className: 'text-end' },
            { title: 'Marka / Model', name: 'markaModel', order: 0, isVisible: false },
            { title: 'Açıklama', name: 'aciklama', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });

    const changeTake = (_take: number) => getData({ ...filter, currentPage: 1, skip: 0, take: _take });

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const secili = () => data.list.filter(x => x.isSelected);

    const updateKayit = async (_id: string | undefined = undefined) => {
        navigate('/sigorta/listadd?id=' + (_id ? _id : secili()[0].sigortaPolicesiId));
    }

    const copyKayit = () => {
        const s = secili();
        if (s.length != 1) {
            toast.error('Kopyalamak için tek poliçe seçin.');
            return;
        }
        navigate('/sigorta/listadd?kopya=' + s[0].sigortaPolicesiId);
    }

    const deleteKayit = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await SigortaService.sil(secili().map(x => x.sigortaPolicesiId));

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success('Seçilen poliçeler silindi.')

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: SigortaListIstegi | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response = await SigortaService.getList(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data ?? { list: [], totalRecordCount: 0 });
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            list: data.list.map(function (x) {
                if (x.sigortaPolicesiId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.list.length == secili().length;

        setData({
            ...data,
            list: data.list.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData({ ...filter, currentPage: 1, skip: 0 });
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await SigortaService.exportList(buildExcelRequest(filter, mode, secili().map(x => x.sigortaPolicesiId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Seçimli kolon filtrelerinin seçenekleri tek istekte gelir; ilk açılan kolon yükler, diğerleri hatırlar.
    const secenekler = useRef<Promise<SigortaSecenekleri> | undefined>(undefined);

    const secenekYukle = (al: (s: SigortaSecenekleri) => { value: string | number, label: string }[]) => async (): Promise<ColumnFilterOption[]> => {
        if (!secenekler.current)
            secenekler.current = SigortaService.secenekler().then(r => {
                if (!r.isSuccess)
                    throw r.message;
                return r.data as SigortaSecenekleri;
            });

        try {
            return al(await secenekler.current).map(x => ({ value: String(x.value), label: x.label }));
        } catch (error: any) {
            secenekler.current = undefined;
            toast.error(error);
            return [];
        }
    }

    const plakaYukle = async (): Promise<ColumnFilterOption[]> => {
        var response = await SigortaService.plakalar();

        return response.isSuccess ? (response.data as SigortaAracBilgisi[]).map(x => ({ value: x.vehicleId, label: x.plaka })) : [];
    }

    // Kolon adları backend'deki eşlemeyle (SigortaListe) aynı.
    const sortableColumns = ['plaka', 'belgeTuruAdi', 'policeNo', 'durumAdi', 'baslangicTarihiStr', 'bitisTarihiStr', 'kalanGun', 'aracCinsi', 'markaModel', 'sigortaFirmasi', 'acente', 'tutar', 'dovizCinsi', 'tutarTL', 'teminatBedeli', 'ekTeminatBedeli', 'aciklama'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        plaka: { type: 'select', allowEmpty: false, loadOptions: plakaYukle },
        belgeTuruAdi: { type: 'select', allowEmpty: false, loadOptions: secenekYukle(s => s.belgeTurleri) },
        policeNo: { type: 'text' },
        durumAdi: { type: 'select', allowEmpty: false, loadOptions: secenekYukle(s => s.durumlar) },
        baslangicTarihiStr: { type: 'date' },
        bitisTarihiStr: { type: 'date' },
        kalanGun: { type: 'number' },
        aracCinsi: { type: 'text' },
        markaModel: { type: 'text' },
        sigortaFirmasi: { type: 'select', allowEmpty: false, loadOptions: secenekYukle(s => s.sigortaFirmalari as SigortaSecenek[]) },
        acente: { type: 'select', allowEmpty: false, loadOptions: secenekYukle(s => s.acenteler as SigortaSecenek[]) },
        tutar: { type: 'number' },
        dovizCinsi: { type: 'select', allowEmpty: false, loadOptions: secenekYukle(s => s.dovizCinsleri as SigortaSecenek[]) },
        tutarTL: { type: 'number' },
        teminatBedeli: { type: 'number' },
        ekTeminatBedeli: { type: 'number' },
        aciklama: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: SigortaKaydi, column: string, className: string | undefined) => {
        var item2: any = item;
        var deger = item2[column];

        if (column == 'tutar' || column == 'tutarTL' || column == 'teminatBedeli' || column == 'ekTeminatBedeli')
            deger = tutarYaz(deger);
        else if (column == 'durumAdi')
            deger = <span className={'badge ' + durumRozeti(item.durum)}>{item.durumAdi}</span>;
        else if (column == 'kalanGun')
            deger = <span className={'badge ' + uyariRozeti(item.uyari)} title={item.uyariAdi}>{item.kalanGun}</span>;

        return <td className={className} onClick={() => setItemSelected(item.sigortaPolicesiId)} onDoubleClick={() => updateKayit(item.sigortaPolicesiId)}>{deger}</td>;
    }

    // Dip toplam: filtrelenmiş bütün kayıtlar; farklı döviz varsa tutar toplamı yazılmaz.
    const getTotalValue = (column: string, columnIndex: number, className: string | undefined) => {
        const t = data.toplamlar;

        if (columnIndex == 0)
            return <td className={className}>Toplam</td>;

        if (column == 'tutar')
            return <td className={className}>{!t ? '' : t.farkliDoviz ? FARKLI_DOVIZ : tutarYaz(t.tutar)}</td>;

        if (column == 'dovizCinsi')
            return <td className={className}>{t && !t.farkliDoviz ? t.dovizCinsi : ''}</td>;

        if (column == 'tutarTL')
            return <td className={className}>{t ? tutarYaz(t.tutarTL) : ''}</td>;

        return <td className={className}></td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <SigortaListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    setFilter={setFilter}
                    selectedCount={secili().length}
                    onSearchSubmit={onSearchSubmit}
                    deleteFunction={deleteKayit}
                    updateFunction={updateKayit}
                    copyFunction={copyKayit}
                    sigortasizAraclar={() => setSigortasizAcik(true)}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.list.length > 0 && secili().length == data.list.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map((item) =>
                                            <tr key={item.sigortaPolicesiId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.sigortaPolicesiId)} className='form-check-input' type='checkbox' checked={!!item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>

                                {
                                    data.list.length > 0 && (
                                        <tfoot>
                                            <tr className='fw-bolder text-gray-800'>
                                                <td style={{ width: 1 }}></td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment key={column.name}>{getTotalValue(column.name, columnIndex, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        </tfoot>
                                    )
                                }
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={secili().length}
                    />
                </KTCard>
            </Content>

            <SigortasizAraclarModal show={sigortasizAcik} onClose={() => setSigortasizAcik(false)} />
        </React.Fragment>
    )
}

export default SigortaList;
